import { Main, Row, SectionWrapper } from '@/components/layouts/Containers';
import styles from './AboutCompany.module.scss';
import {
  accordionData,
  categoryData,
  contacts,
  founder,
  name,
  requisitesData,
} from './AboutCompany.data';
import { DownloadBtn, Phone, SwiperCards } from '@/components/UI';
import { MainAccordion, MapComponent } from '@/components/Logic';
import parse from 'html-react-parser';
import Requisites from './components/Requisites/Requisites';

export const meta = {
  title: 'Сахалинское ипотечное агенство - О нас',
  description:
    'Общество является коммерческой организацией, основной целью которого является организация системы жилищного ипотечного кредитования в Сахалинской области. Средства, получаемые от продажи жилья в строящихся ипотечных домах и от деятельности на рынке ипотечного кредитования, направляются на увеличение оборотных средств для дальнейшего инвестирования в жилищное строительство и увеличения объемов ипотечного кредитования жителей Сахалинской области.',
  keywords:
    'Наша компания, О нас, Ипотечное агенство, Сахалин, Безопасность, Удобство, Покупка, Продажа, Квартира. недвижимость',
};

const About = () => {
  const coords = [46.96346, 142.737582];

  return (
    <Main meta={meta}>
      <SectionWrapper pbNone className={styles.wrapper}>
        <h1 className={'titleHeader'}>О нашей компании</h1>

        <Row>
          <Row.Header>
            <h2>Полное фирменное наименование</h2>
          </Row.Header>
          <Row.Content>
            <p className={'mb-md-2'}>
              <span>{name.fullName}</span>
            </p>
          </Row.Content>
        </Row>
        <Row>
          <Row.Header>
            <h2>Сокращенное наименование</h2>
          </Row.Header>
          <Row.Content>
            <p className={'mb-5'}>
              <span>{name.shortName}</span>
            </p>

            <p className={'mb-5'}>{name.meaning}</p>
          </Row.Content>
        </Row>
        <Row>
          <Row.Header>
            <h2>Номера телефонов</h2>
          </Row.Header>
          <Row.Content>
            {contacts.phones.map((item, index) => (
              <p className='mb-md-2' key={index}>
                <span className={styles.subtitle}>{item.place}</span>
                <Phone className='mb-2' phone={item.phone} />
              </p>
            ))}
          </Row.Content>
        </Row>
        <Row>
          <Row.Header>
            <h2>Электронная почта</h2>
          </Row.Header>
          <Row.Content>
            <p className={'mb-md-2'}>
              <span className={styles.text}>{contacts.email}</span>
            </p>
          </Row.Content>
        </Row>
        <Row>
          <Row.Header>
            <h2>Место нахождения</h2>
          </Row.Header>
          <Row.Content>
            <p className={'mb-md-2'}>
              <span className={styles.text}>
                Сахалинская область, г. Южно-Сахалинск, <br />
                ул. Дзержинского, д. 21 оф. 219
              </span>
            </p>
          </Row.Content>
        </Row>
      </SectionWrapper>

      <SectionWrapper>
        <Row>
          <Row.Header>
            <h2>Часы приема</h2>
            <p>
              Только по будням <br />
              09:00 -- 18:00
            </p>
          </Row.Header>

          <Row.Content>
            <MapComponent
              mapsStyles={styles.map}
              defaultCoords={coords}
              isSingleMarker={true}
              isMovable={true}
              zoom={17}
            />
          </Row.Content>
        </Row>
      </SectionWrapper>

      <SectionWrapper>
        <Row>
          <Row.Header>
            <h1>Учредитель</h1>
          </Row.Header>
          <Row.Content>
            <p>{parse(founder)}</p>
          </Row.Content>
        </Row>
      </SectionWrapper>

      <SectionWrapper>
        <Row>
          <Row.Header>
            <h1>Реквизиты</h1>
          </Row.Header>
          <Row.Content>
            <Requisites>
              {requisitesData.map((item, index) => {
                return (
                  <Requisites.Item key={index} title={item.title} description={item.description} />
                );
              })}
            </Requisites>
          </Row.Content>
        </Row>
      </SectionWrapper>

      <SectionWrapper>
        <Row>
          <Row.Header>
            <h1>Корпоративная информация</h1>
          </Row.Header>
          <Row.Content>
            <MainAccordion data={accordionData} />
          </Row.Content>
        </Row>
      </SectionWrapper>

      <SectionWrapper>
        <Row>
          <Row.Header>
            <h1>Информация по закупкам</h1>
          </Row.Header>
          <Row.Content>
            <p className={'mb-2'}>Об утверждении перечня СМП</p>
            <DownloadBtn href='docs/AboutCompany/svod2018.pdf' />
          </Row.Content>
        </Row>
      </SectionWrapper>

      <SwiperCards title='Другие разделы' list={categoryData} slideWidth={420} />
    </Main>
  );
};

export default About;
